module.exports = __webpack_public_path__ + "img/calendar-bg.4ab639c2.jpg";